import { api } from 'src/plugins/axios'
import { notify } from 'src/plugins/notify'

/**
 * System wide settings an admin flips from the Settings page.
 *
 * Loaded once when the app starts. Until it loads, address verification reads
 * as on, which is also the server's default.
 */
export default {
  namespaced: true,
  state: {
    loaded: false,
    saving: false,
    values: {},
  },
  getters: {
    addressVerificationEnabled: state => state.values.ADDRESS_VERIFICATION_ENABLED !== '0',
  },
  mutations: {
    setValues (state, values) {
      state.values = Object.assign({}, values)
      state.loaded = true
    },
    setSaving (state, saving) {
      state.saving = saving
    },
  },
  actions: {
    async fetch ({ commit }) {
      try {
        const { data } = await api.get('/settings')
        if (data && data.success) commit('setValues', data.payload.settings)
      } catch (err) {
        console.log('could not load settings', err)
      }
    },

    async save ({ commit }, { key, value }) {
      commit('setSaving', true)
      try {
        const { data } = await api.post('/settings', { key, value })
        if (data && data.success) commit('setValues', data.payload.settings)
        notify.create({
          message: (data && data.message) || 'Could not save the setting.',
          type: data && data.success ? 'positive' : 'negative',
        })
        return !!(data && data.success)
      } catch (err) {
        notify.create({ message: 'Could not save the setting.', type: 'negative' })
        return false
      } finally {
        commit('setSaving', false)
      }
    },
  },
}
